import { HttpErrorResponse } from "@angular/common/http";
import { LearnerList } from "src/app/_models/LearnerList";

export interface LearnerState {
    learnerTableRecords: LearnerList[];
    learnerRecordsLength: number;
    learnerTableError: HttpErrorResponse;
    currentPageNumber: number;
    
    updateLearnerStatusLoader: boolean;
    deleteLearnerLoader: boolean;
    learnerTableLoader: boolean;
    isInitialLoadFlowReset: boolean;
    isUpdateLearnerStatus: boolean;
    isDeleteLearner: boolean;

    groupLearnerCount: string;
    groupLearnerCountLoader: boolean;
    groupLearnerCountError: HttpErrorResponse;

    multipleLearnerIds: number[];
}

export const initialLearnerState: LearnerState = {
    learnerTableRecords: [],
    learnerRecordsLength: 0,
    learnerTableError: null,
    currentPageNumber: 0,

    updateLearnerStatusLoader: false,
    deleteLearnerLoader: false,
    learnerTableLoader: false,
    isInitialLoadFlowReset: false,
    isUpdateLearnerStatus: false,
    isDeleteLearner: false,

    groupLearnerCount: null,
    groupLearnerCountLoader: false,
    groupLearnerCountError: null,

    multipleLearnerIds: null,
}